var app = angular.module('leonardo');

var AddPropertyDialog = function($scope, $state, $timeout, PortfolioService) {

  $scope.portfolioService = PortfolioService;

  $scope.showItemAddDialog = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) return;
    $timeout(function () {
      $state.go('portfolios.property-add', {pk: $scope.portfolio});
    }, 100);
    $scope.closeThisDialog();
  };
};

app.controller('AddPropertyDialog', ['$scope', '$state', '$timeout', 'PortfolioService', AddPropertyDialog]);